// Function to handle add to playlist button click
function handleAddToPlaylist(e) {
  e.preventDefault();
  e.stopPropagation();
  
  const button = $(this);
  const dropdown = button.closest('.input-group').find('.playlist-select');
  const playlistId = dropdown.val();
  const clipId = dropdown.data('clip-id');
  const clipType = dropdown.data('clip-type') || 'ObservationClip';
  
  if (!playlistId) {
    toastr.warning('Please select a playlist', '', {
      'closeButton': true,
      'progressBar': true,
      'positionClass': 'toast-top-center'
    });
    return;
  }
  
  button.prop('disabled', true);
  
  $.ajax({
    url: `/video_centre/playlists/${playlistId}/add_clip`,
    type: 'POST',
    data: {
      clip_id: clipId,
      clip_type: clipType
    },
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    success: function(response) {
      if (response.status === 'success') {
        toastr.success(response.message, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
        dropdown.val('');
      } else if (response.status === 'duplicate') {
        toastr.info(response.message, '', {
          'closeButton': true,
          'progressBar': true,
          'positionClass': 'toast-top-center'
        });
      }
    },
    error: function(xhr) {
      let message = 'Error adding clip to playlist';
      if (xhr.responseJSON && xhr.responseJSON.message) {
        message = xhr.responseJSON.message;
      }
      toastr.error(message, '', {
        'closeButton': true,
        'progressBar': true,
        'positionClass': 'toast-top-center'
      });
    },
    complete: function() {
      button.prop('disabled', false);
    }
  });
}

// Initialize playlist functionality
function initializePlaylistHandlers() {
  // Remove any existing handlers first to prevent duplicates
  $(document).off('click.playlist', '.add-to-playlist-btn');
  
  // Use namespaced event for better control
  $(document).on('click.playlist', '.add-to-playlist-btn', handleAddToPlaylist);
  
  // Also bind directly to existing buttons (for modals)
  $('.add-to-playlist-btn').off('click.direct').on('click.direct', handleAddToPlaylist);
}

// Initialize on page load
document.addEventListener("turbolinks:load", () => {
  initializePlaylistHandlers();
});

// Also initialize when DOM is ready (fallback for non-turbolinks scenarios)
$(document).ready(function() {
  initializePlaylistHandlers();
});

// Reinitialize when modal content is loaded via AJAX
$(document).on('ajax:success', function(e, data, status, xhr) {
  setTimeout(function() {
    initializePlaylistHandlers();
  }, 200); // Small delay to ensure DOM is updated
});

// Also reinitialize on ajax:complete
$(document).on('ajax:complete', function(e, xhr, status) {
  setTimeout(function() {
    initializePlaylistHandlers();
  }, 200);
});

// Listen for any modal show events
$(document).on('shown.bs.modal', '.modal', function() {
  initializePlaylistHandlers();
});

// Also try mutation observer for dynamic content
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const hasPlaylistButton = $(mutation.addedNodes).find('.add-to-playlist-btn').length > 0 ||
                                  $(mutation.addedNodes).hasClass('add-to-playlist-btn');
        if (hasPlaylistButton) {
          setTimeout(initializePlaylistHandlers, 100);
        }
      }
    });
  });
  
  // Start observing when document is ready
  $(document).ready(function() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}